import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { CarePathBadgesComponent } from '../care-path-badges/care-path-badges.component';
import { riskLevelClass, riskLevelLabel } from '../../../my-workspace/utils/my-workspace.utils';
import { RiskLevel } from '../../../my-workspace/models/my-workspace.models';

// Mesmos SVGs usados na avaliação do zoom guest-room (assets/icons/faces).
// 5 rostos para 6 níveis: o pior rosto cobre os níveis 5 e 6.
const RISK_LEVEL_FACES: Record<RiskLevel, string> = {
  '1': 'assets/icons/faces/excellent.svg',
  '2': 'assets/icons/faces/good.svg',
  '3': 'assets/icons/faces/average.svg',
  '4': 'assets/icons/faces/bad.svg',
  '5': 'assets/icons/faces/verybad.svg',
  '6': 'assets/icons/faces/verybad.svg',
};

@Component({
  selector: 'mihmo-customer-header-badges',
  standalone: true,
  templateUrl: './customer-header-badges.component.html',
  styleUrls: ['./customer-header-badges.component.scss'],
  imports: [NgClass, CarePathBadgesComponent],
})
export class CustomerHeaderBadgesComponent {
  @Input({ required: true }) customerId: string;

  /**
   * Vem por input (via ni-page-default) porque a página já carrega esse dado —
   * o board de pontuação busca GET /journey-plan/customer/:id e emite o payload;
   * buscar aqui de novo duplicaria a chamada ao mesmo endpoint.
   */
  @Input() riskLevel: RiskLevel | null = null;

  /**
   * True enquanto a requisição que traz o `riskLevel` está pendente. Distingue
   * "ainda não chegou" (mostra shimmer) de "cliente sem nível de risco"
   * (não mostra nada) — os dois casos têm `riskLevel` nulo.
   */
  @Input() loadingRiskLevel = false;

  readonly riskLevelClass = riskLevelClass;
  readonly riskLevelLabel = riskLevelLabel;

  riskLevelFace(level: RiskLevel): string {
    return RISK_LEVEL_FACES[level] ?? '';
  }
}
